import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { RoleSuRoleAddUsersComponent } from "../shared/role-su-role-add-users/role-su-role-add-users.component";
import { SuRoleChangeUsersRequest } from "../shared/SuRoleChangeUsersRequest";

@Component({
	selector: "caass-role-su-user-by-role",
	templateUrl: "./role-su-user-by-role.component.html",
	styleUrls: ["./role-su-user-by-role.component.css"],
})
export class RoleSuUserByRoleComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadRole();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	userpagerows: any = 10;
	userpagefirst: any = 0;

	SelectedRole: any;
	lstRole: any = [];

	SelectedUsers: any = [];
	lstUsers: any = [];

	lstPersonTypeDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];

	UserCols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		{ field: "SchoolFullName", header: "Home School" },
		// { field: "UserLevelDesc", header: "User Level" },
		// { field: "ActiveDesc", header: "Active" },
		// { field: "SchoolCount", header: "School Count" },
	];

	LoadingRole: boolean = false;
	LoadingUser: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////

	loadRole() {
		this.LoadingRole = true;

		var result = this.dataService.RoleAdminSuRoleListSelect();
		result.subscribe(
			(response) => {
				this.lstRole = response;

				this.SelectedRole = null;
				if (this.lstRole.length > 0) {
					this.SelectedRole = this.lstRole[0];
				}

				this.loadUsers();

				this.LoadingRole = false;
			},
			(error) => {
				this.LoadingRole = false;
			}
		);
	}

	loadUsers() {
		this.errorMessage = "";

		this.lstUsers = [];
		this.SelectedUsers = [];
		this.LoadingUser = true;

		var result = this.dataService.RoleAdminSuSelectUserByRole(-1, this.SelectedRole.RoleID);
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonTypeDesc)));
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.ActiveDesc)));

				this.LoadingUser = false;
			},
			(error) => {
				this.LoadingUser = false;
			}
		);
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////

	onUserRefresh() {
		this.loadUsers();
	}

	onAddUsers() {
		var popup_Width = (window.innerWidth - 80).toString() + "px";
		var distSchool: any = {
			SchoolID: -1,
			SchoolName: "District",
			SchoolFullName: "District",
		};

		var ref = this.dialogService.open(RoleSuRoleAddUsersComponent, {
			header: "Add Users",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				School: distSchool,
				Role: this.SelectedRole,
			},
		});
		ref.onClose.subscribe((response: number) => {
			if (response == -1 || response > 0) {
				this.loadUsers();
			}
		});
	}

	onRemoveUsers() {
		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select Users to remove from role";
			return;
		}

		//
		// Confirm Remove Role?
		//
		var Msg =
			"You are about to remove the " +
			this.SelectedRole.RoleDesc +
			" from " +
			this.SelectedUsers.length +
			" user" +
			(this.SelectedUsers.length == 1 ? "" : "s") +
			" for all the schools they have access to. This might remove the user from the user groups they are in. Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "userbyroleconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Remove Roles",
			icon: "fa",
			accept: () => {
				this.onFinishRemoveUsers(-1);
			},
		});
	}

	onFinishRemoveUsers(DistrictOption: number) {
		var lstUIDs: number[] = [];

		lstUIDs = this.SelectedUsers.map((user) => user.UserID);

		var parms: SuRoleChangeUsersRequest = {
			SchoolID: DistrictOption,
			RoleID: this.SelectedRole.RoleID,
			lstUserIDs: lstUIDs,
		};

		var result = this.dataService.SuRoleRemoveUsers(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "userbyrolestatus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User Roles were removed successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "userbyrolestatus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Remove User Roles: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"User Level",`;
		DataStr += `"Active",`;
		DataStr += `"# of Schools"`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUsers.length; z++) {
			var next = this.lstUsers[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.UserLevelDesc + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += `"` + next.SchoolCount + `"`;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var fRole = this.ReplaceAllOccur(this.SelectedRole.RoleDesc, " ", "_");
		fRole = this.ReplaceAllOccur(fRole, "/", "");
		fRole = this.ReplaceAllOccur(fRole, "\\", "");
		var FileName = "UserByRole_" + fRole;

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////

	onSelectedRoleChange(val) {
		this.SelectedRole = val;

		this.loadUsers();
	}

	onUserRowSelect(val) {
		this.errorMessage = "";
	}

	onUserRowUnselect(val) {
		this.errorMessage = "";
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingRole == true || this.LoadingUser == true || this.Processing == true;
	}
	////////////////////////////////////////////////
}
